import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "On writing every day",
  "description": "",
  "published": "2011-11-24T00:00:00.000Z",
  "redirect_from": ["/blog/on-writing-every-day/swizec/3058"],
  "categories": "Arts, NaNoWriMo, Stephen King, Uncategorized, Word count, Writers Resources, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/11193169_gal7.jpg",
        "alt": "Stephen King",
        "title": "Stephen King"
      }}></img></p>
    <p>{`Yesterday someone mentioned on twitter that it's amazing how I write a blogpost every day, especially considering the quality of my posts. Leaving aside for a moment considerations that this might have been an epic case of sarcasm ... writing a post every day isn't that difficult anyway.`}</p>
    <p>{`When you think about it, everyone probably writes a blogpost's worth of words every day.`}</p>
    <ol>
      <li parentName="ol">{`Many people tweet about 20 times a day - that's roughly 140 words right there. Enough for a daily tumblr blogpost thing`}</li>
      <li parentName="ol">{`Those using facebook probably write about 5 status updates a day - 50 words right there?`}</li>
      <li parentName="ol">{`And you probably write email as well. This gives you at least 300 words a day.`}</li>
      <li parentName="ol">{`Hang out on skype or IRC? Doubtlessly at least 200 words a day right there as well.`}</li>
    </ol>
    <p>{`Considering those numbers, it's safe to say the average internet citizen writes 500 to 1000 or even 1500 words `}<em parentName="p">{`every single day`}</em>{`. In my experience the sweet spot for blogs is ~600 words.`}</p>
    <p>{`This means that each and every one of you writes a blog post or two every day. Why aren't you publishing this anywhere?`}</p>
    <p>{`Statistics aside, writing is mostly about practice. I would love nothing more than claim writing is an inherent talent and make myself feel super special - but I can't. It's just practice, practice and when you think you're just about done, some more practice.`}</p>
    <p>{`The part that isn't practice is the discipline to plomp your arse down and `}<em parentName="p">{`write`}</em>{` be it rain or snow, sunshine or a cat begging to be fed. Staring at a blank page is always a little daunting, but once you actually get going your mind will usually take care of the rest and keep you going.`}</p>
    <p>{`It helps if you can type too ... knowledge of at least one human language doesn't hurt either.`}</p>
    <p>{`Doing the daily `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/750-words-a-day-keeps-the-insanity-away/swizec/1703",
        "title": "750 words a day keeps the insanity away"
      }}>{`750 words`}</a>{` has helped me immensely with the part of plomping my arse down and writing. My problem has always been that I'm sort of good with keeping a train of thought going - much to the surprise of anyone who's ever talked to me in person - and delivering in a digestible sometimes even entertaining form. I'm lucky that my writing rarely makes people vomit.`}</p>
    <p>{`After 750words gave me an incentive to write roughly three pages of text every day, and assured me that it really really doesn't matter what I write - silencing my inner critic so to say - everything got much simpler. Combined with the daily blogpost my baseline for writing every day is probably around 1400 words every single day. And that's before all the twitter and email!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-24-at-2.27.06-PM.png",
        "alt": "Writing incentives!",
        "title": "Writing incentives!"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-24-at-2.27.18-PM.png",
        "alt": "Quite a bit of words",
        "title": "Quite a bit of words"
      }}></img></p>
    <p>{`Actually, now that I think about it ... why am I writing so much and not working on the next big novel, like I've wanted to since I was 10? There's a whole competition going on right now (`}<a parentName="p" {...{
        "href": "http://www.nanowrimo.org",
        "title": "NaNoWriMo"
      }}>{`NaNoWriMo`}</a>{`) about getting people to write 1666 words every day to produce a novel in a month. Looks like I'm producing a novel-length wall of text every month and a half ...`}</p>
    <p>{`But anyway, if you want to start writing something every day, and I heartily suggest that you do, there are two easy steps to take: `}<em parentName="p">{`write`}</em>{` and `}<em parentName="p">{`write`}</em>{`. It's that simple.`}</p>
    <p>{`If you want also to show anyone what you've written, I suggest giving `}<a parentName="p" {...{
        "href": "http://www.amazon.com/gp/product/1439156816/ref=as_li_ss_tl?ie=UTF8&tag=ageewitahat-20&linkCode=as2&camp=217145&creative=399369&creativeASIN=1439156816"
      }}>{`On Writing, by Stephen King`}</a>{` a read. Awesome book that will fix up your style in no time. Really helped iron out all the "look at me, I'm a writer and this is `}<em parentName="p">{`significant`}</em>{`" bullshit out of the way I write.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://chyrondave.wordpress.com/2011/11/20/things-that-changed-in-november-for-nanowrimo/"
        }}>{`Things That Changed in November for NaNoWriMo`}</a>{` (chyrondave.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://eulana.com/2011/11/23/how-nanowrimo-could-change-your-writing-life-a-success-story-by-lexus-luke/"
        }}>{`How NaNoWriMo Could Change Your Writing Life: A Success Story by Lexus Luke`}</a>{` (eulana.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://chyrondave.wordpress.com/2011/11/21/things-you-only-hear-during-nanowrimo/"
        }}>{`Things You Only Hear During NaNoWriMo`}</a>{` (chyrondave.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=f61c0b0e-74f0-4cca-a57c-d36bade57189",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      